/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roomannouncementnoroom3Inputs */

const en_roomannouncementnoroom3 = /** @type {(inputs: Roomannouncementnoroom3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Live Room is running right now.`)
};

const de_roomannouncementnoroom3 = /** @type {(inputs: Roomannouncementnoroom3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade läuft kein Live Room.`)
};

/**
* | output |
* | --- |
* | "No Live Room is running right now." |
*
* @param {Roomannouncementnoroom3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementnoroom3 = /** @type {((inputs?: Roomannouncementnoroom3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementnoroom3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementnoroom3(inputs)
	return de_roomannouncementnoroom3(inputs)
});
export { roomannouncementnoroom3 as "roomAnnouncementNoRoom" }